import { map, size } from "lodash";
import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";
import { arrayWithNEmptyItems } from "../../../../utils/array";
import { timeStampToDate, formatUpperCase } from "../../../../utils/formats";
import { Text } from "../styles";

const InformacoesFinanceirasSection = (props) => {
  const { clienteContasLoading, clienteContas } = props;

  return (
    <>
      <Grid container spacing={3}>
        {size(clienteContas) == 0 && !clienteContasLoading && (
          <Grid item xs={12}>
            <Text>Sem dados.</Text>
          </Grid>
        )}
        {map(
          clienteContasLoading ? arrayWithNEmptyItems(1) : clienteContas,
          (it) => {
            return (
              <>
                <Grid item md={4}>
                  <Input
                    loading={clienteContasLoading}
                    label="Banco"
                    value={formatUpperCase(it.nomeBanco)}
                  />
                </Grid>
                <Grid item md={2}>
                  <Input
                    loading={clienteContasLoading}
                    label="Data de abertura"
                    value={timeStampToDate(it.dataAbertura)}
                  />
                </Grid>
                <Grid item md={2}>
                  <Input
                    loading={clienteContasLoading}
                    label="Agência"
                    value={it.codigoAgencia}
                  />
                </Grid>
                <Grid item md={2}>
                  <Input
                    loading={clienteContasLoading}
                    label="Conta"
                    value={it.numeroConta}
                  />
                </Grid>
                <Grid item md={2}>
                  <Input
                    loading={clienteContasLoading}
                    label="Digito"
                    value={undefined}
                  />
                </Grid>
              </>
            );
          }
        )}
      </Grid>
    </>
  );
};

export default InformacoesFinanceirasSection;
